import { render } from "./AddDocumentModal.vue?vue&type=template&id=43969a2e&scoped=true"
import script from "./AddDocumentModal.vue?vue&type=script&lang=js"
export * from "./AddDocumentModal.vue?vue&type=script&lang=js"

import "./AddDocumentModal.vue?vue&type=style&index=0&id=43969a2e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43969a2e"]])

export default __exports__